import { Instance } from 'mobx-state-tree';
import { InsightsDriverBreakdownOvertimeDtoEdgeModelBase } from './InsightsDriverBreakdownOvertimeDtoEdgeModel.base';

/* The TypeScript type of an instance of InsightsDriverBreakdownOvertimeDtoEdgeModel */
export interface InsightsDriverBreakdownOvertimeDtoEdgeModelType extends Instance<typeof InsightsDriverBreakdownOvertimeDtoEdgeModel.Type> {}

/* A graphql query fragment builders for InsightsDriverBreakdownOvertimeDtoEdgeModel */
export {
  selectFromInsightsDriverBreakdownOvertimeDtoEdge,
  insightsDriverBreakdownOvertimeDtoEdgeModelPrimitives,
  InsightsDriverBreakdownOvertimeDtoEdgeModelSelector,
} from './InsightsDriverBreakdownOvertimeDtoEdgeModel.base';

/**
 * InsightsDriverBreakdownOvertimeDtoEdgeModel
 */
export const InsightsDriverBreakdownOvertimeDtoEdgeModel = InsightsDriverBreakdownOvertimeDtoEdgeModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
